export const ROUTES = {
  home: '/',
  login: '/login',
  users: '/users',
  incident: '/incident/:id',
  report: '/report/:id',
  escort: '/escort/:id',
  escortCompositions: '/escort/:id/compositions'
};
